import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  template: '',
})
export class EmptyRouteComponent {
  constructor(private router: Router) {}
}
